'use strict';

var _notify = require('linksoft/notify');

var _notify2 = _interopRequireDefault(_notify);

var _localize = require('linksoft/core/localize');

var _localize2 = _interopRequireDefault(_localize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//const $ = require("jquery");

var Resx = (0, _localize2.default)('Messages');

function insertFileManagerFolder(parentFolder, name) {
    if (!name) {
        _notify2.default.error(Resx.Messages.FileManagerEmptyName);
        return;
    }

    var fileManagerService = abp.services.api.filemanager;
    fileManagerService.insertFolder({ Name: name, ParentFolderId: parentFolder }).done(function (result) {
        folderAdded();
        _notify2.default.success(Resx.Messages.FileManagerNewFolderCreated);
    }).fail(function (err) {
        _notify2.default.error(L(err.responseJSON.error.message));
    });
}

module.exports = exports.default = function () {
    window.linksoft.insertFileManagerFolder = insertFileManagerFolder;
};


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/fileManagerFolder.js
// module id = 434
// module chunks = 0